import type { ComponentProps, ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface DashboardContainerProps extends ComponentProps<'div'> {
  children: ReactNode
  className?: string
}

export function DashboardContainer({ children, className, ...props }: DashboardContainerProps) {
  return (
    <div
      className={cn(
        'mx-auto w-full',
        'max-w-full px-4',
        'lg:max-w-6xl lg:px-6',
        'xl:max-w-7xl xl:px-8',
        '2xl:max-w-[1440px] 2xl:px-12',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}
